import styled from 'styled-components';
import { atomicBlockContainerWidth, colorUsage, fontSize, getSpacing } from 'stylesheet';
var Container = styled.div.withConfig({
  displayName: "SlideshowEmbedBlockstyle__Container",
  componentId: "sc-1c4n1qm-0"
})(["display:flex;flex-direction:column;justify-content:center;width:", ";margin:auto;"], atomicBlockContainerWidth);
var ImageWrapper = styled.div.withConfig({
  displayName: "SlideshowEmbedBlockstyle__ImageWrapper",
  componentId: "sc-1c4n1qm-1"
})(["position:relative;"]);
var IconWrapper = styled.span.withConfig({
  displayName: "SlideshowEmbedBlockstyle__IconWrapper",
  componentId: "sc-1c4n1qm-2"
})(["position:absolute;top:50%;left:50%;transform:translate(-50%,-50%) scale(3);& path{fill:", ";}"], colorUsage.whiteIconColor);
var Image = styled.img.withConfig({
  displayName: "SlideshowEmbedBlockstyle__Image",
  componentId: "sc-1c4n1qm-3"
})(["max-width:100%;height:auto;"]);
var Label = styled.p.withConfig({
  displayName: "SlideshowEmbedBlockstyle__Label",
  componentId: "sc-1c4n1qm-4"
})(["margin:", " auto;font-size:", ";text-align:center;"], getSpacing(1), fontSize.large);
export { Container, IconWrapper, Image, ImageWrapper, Label };